import { useCallback, useMemo, useState } from 'react';

export interface MultimediaSelection {
  selected: ReadonlySet<string>;
  count: number;
  isSelected: (name: string) => boolean;
  toggle: (name: string) => void;
  selectAll: (names: string[]) => void;
  clear: () => void;
}

export const useMultimediaSelection = (): MultimediaSelection => {
  const [selected, setSelected] = useState<ReadonlySet<string>>(new Set());

  const toggle = useCallback((name: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      return next;
    });
  }, []);

  const selectAll = useCallback((names: string[]) => {
    setSelected(new Set(names));
  }, []);

  const clear = useCallback(() => {
    setSelected(new Set());
  }, []);

  const isSelected = useCallback((name: string) => selected.has(name), [selected]);

  return useMemo(
    () => ({
      selected,
      count: selected.size,
      isSelected,
      toggle,
      selectAll,
      clear,
    }),
    [selected, isSelected, toggle, selectAll, clear]
  );
};
